import appConfig from "./multidomain.helper";
import pkg from "../../package.json";


export function initializeApp() {
  document.title = `${appConfig.meta.title} - ${pkg.version}`
}
